import { Component, OnInit, Input, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, FormControl } from '@angular/forms';
import { BaseService } from '../../shared/services/base.service';
import BaseDecorator from '../../base-decorator';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'kx-range',
    templateUrl: './range.component.html',
    styleUrls: ['./range.component.scss'],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: RangeComponent,
            multi: true,
        }, {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => RangeComponent), multi: true
        }],
    standalone: false
})
export class RangeComponent extends BaseDecorator implements OnInit {
  @Input() fieldDataSource: any;
  @Input() formControlName: any;
  @Input() question: any;
  @Input() data: any;
  propagateChange = (_: any) => { };
  questionForm: any;
  self: any;
  config: any;

  constructor(
    private baseService: BaseService,
    route: ActivatedRoute,
  ) {
    super(route,'RangeComponent');
    this.self = this
  }

  ngOnInit() {
    this.config = {
      "submitButton" : true,
      "cancelButton" : false,
      "filterForm" : false,
      "clearOnSave": true,
      "delegateSave": true,
      "cancelRoute": ''
    }
    this.baseService.getResourceDef(this.fieldDataSource, (resourceDef) => {
      if (resourceDef) {
        this.questionForm = resourceDef;
        // debugger;
      }
    })
  }

  onSaveFinished(event) {

  }

  valueChangeEnd(e: any) {
    console.log("valueChangeEnd ", this.form.value);
    this.propagateChange(this.form.value)

  }

  get value() {
    return "";
  }

  set value(val) {
    this.propagateChange(val);
  }

  writeValue(value) {
    if (value) {
    }
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }
  registerOnTouched(fn: any): void {

  }
  validate(value: FormControl) {
    let x: any = this.questionForm.blocks[0].fields[0].validations[0].expression;
    let item = value.value;
    if (eval(x)) {
      for(let key in item) {
        if (item.hasOwnProperty(key)) {
          this.form.controls[key].setErrors(null);
        }
      }
      value['_parent'].controls[this.question.key].setErrors(null);
    }
    else {
      for(let key in item) {
        if (item.hasOwnProperty(key)) {
          this.form.controls[key].setErrors({ 'incorrect': true });
        }
      }
      return {
        invalid: true
      };
    }


    // if (this._validations) {
    //   return this.validateService.setValidation(value, this._validations);
    // }
  }

}
